/* eslint-disable react/jsx-props-no-spreading */
import { encryptionKey, restbaseurl } from '../constants'
import Cookies from 'js-cookie';
import { Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import * as ls from "local-storage";
import UserInfo from '../../models/UserInfo';
import { RestDataSource } from '../../utils/RestDataSource';
import { jwtVerify, SignJWT } from 'jose';
import { LoadingSpinner } from 'utils/LoadingSpinner';
import SecureStorage from '../../utils/SecureStorage';
import ErrorPage from '../ErrorPage';

// Disable secure storage by default (prior errors/corruption); rely on sessionStorage for auth (OWASP A02 - no token in localStorage)
let secureStorageHealthy = false;

const AUTH_PAYLOAD_KEY = 'auth_payload';

/** Sync read of auth payload from sessionStorage (no JWT; not in localStorage to avoid XSS token theft) */
function getAuthPayloadSync() {
     try {
          const raw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(AUTH_PAYLOAD_KEY) : null;
          if (raw) {
               const parsed = JSON.parse(raw);
               if (parsed && typeof parsed === 'object') return parsed;
          }
          return null;
     } catch (e) {
          return null;
     }
}

function parseJwt(token) {
     const base64Url = token.split('.')[1];
     const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
     const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
     console.log('Payload', jsonPayload);
     return JSON.parse(jsonPayload);
}

function updateC1() {
     const expmin = new Date(new Date().getTime() + 20 * 60 * 1000);
     const val1 = Cookies.get('_c1');
     if (val1 !== undefined && val1 !== null) {
          console.log('updateC1  val1', val1);
          Cookies.remove('_c1');
          Cookies.set('_c1', val1, { path: '/', expires: expmin });
          const p = parseJwt(val1);
          console.log('update - C1 Payload', p);
     }
}

async function updateUserInfo(c1 = null) {
     let val1 = c1;
     // OWASP A02: We do not read or store JWT in JS (HttpOnly cookie is set by backend). Only use in-memory when passed.
     const ck = Cookies.get('_c1');
     if (ck != null) {
          val1 = ck;
          console.log('Thru cookie');
     } else if (c1 !== undefined && c1 !== null) {
          val1 = c1;
          // Do not persist JWT to localStorage or cookie - backend already set HttpOnly cookie
          console.log('Thru Params - post login (not stored)');
     }
     if (val1 === undefined || val1 === null) {
          // Try encrypted storage first
          try {
               if (secureStorageHealthy) {
                    val1 = await SecureStorage.getItem('_c1');
                    if (val1) {
                         console.log('Thru Encrypted Local Store');
                    }
               }
               if (!val1) {
                    // Fallback to unencrypted storage
                    val1 = ls.get('_c1');
                    if (val1 && secureStorageHealthy) {
                         console.log('Thru Local Store (unencrypted - migrating)');
                         // Migrate to encrypted storage
                         await SecureStorage.setItem('_c1', val1);
                    }
               }
          } catch (error) {
               console.error('Error retrieving encrypted token:', error);
               val1 = ls.get('_c1');
               console.log('Thru Local Store (fallback)');
               secureStorageHealthy = false;
          }
     }
     console.log('Final Val1', val1);

     if (val1 !== undefined && val1 !== null) {
          const data = parseJwt(val1);
          UserInfo.setUserDetail(data);
     } else {
          // OWASP A02: No JWT in localStorage; restore UserInfo from sessionStorage payload if present
          const payload = getAuthPayloadSync();
          if (payload && payload.username != null) {
               try {
                    UserInfo.setUserDetail({
                         username: payload.username,
                         extradata: {
                              name: payload.loginname || payload.firstname || '',
                              role: payload.roleCode || '',
                              userid: payload.userId
                         }
                    }, true);
                    return;
               } catch (_) {}
          }
          processLogout();
          console.log('updateUserInfo - Cookie / LS / Params not found');
     }
}

async function getValue(key = "") {
     console.log("getValue:", key);
     try {
          // OWASP A02: Auth payload in sessionStorage only (no JWT/token in localStorage)
          let payload = getAuthPayloadSync();

          // One-time migration: move from localStorage to sessionStorage, then clear localStorage
          if (!payload && typeof sessionStorage !== 'undefined') {
               const unencryptedToken = ls.get('token');
               if (unencryptedToken) {
                    try {
                         payload = JSON.parse(atob(unencryptedToken));
                         if (payload && typeof payload === 'object') {
                              sessionStorage.setItem(AUTH_PAYLOAD_KEY, JSON.stringify(payload));
                              ls.remove('token');
                              try { await SecureStorage.removeItem('token_secure'); } catch (_) {}
                              console.log("getValue: Migrated auth payload from localStorage to sessionStorage");
                         }
                    } catch (e) {
                         console.warn('Migration parse failed, clearing', e);
                         ls.remove('token');
                         payload = null;
                    }
               }
          }

          if (payload !== null && payload !== undefined) {
               try {
                    console.log("getValue:", key, "(sessionStorage)");
                    return key === "" ? payload : payload ? payload[key] : null;
               } catch (error) {
                    console.warn('Payload read failed, clearing', error);
                    if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(AUTH_PAYLOAD_KEY);
                    ls.remove('token');
               }
          }
     } catch (error) {
          console.error('Error retrieving auth payload:', error);
     }
     return null;
}

async function setValue(key, value) {
     console.log("setValue:", key, value);

     try {
          // Get current payload (from encrypted or unencrypted storage)
          let payload = null;
          try {
               payload = await getValue();
          } catch (error) {
               console.warn('getValue failed inside setValue, starting fresh payload', error);
          }

          if (payload === null || payload === undefined) {
               payload = {};
          }

          if (payload !== null && payload !== undefined) {
               payload[key] = value;
               console.log("payload:", payload);
               await setAllValue(payload);
          }
     } catch (error) {
          console.error('Error setting value:', error);
     }
}

async function setAllValue(payload) {
     if (payload !== null && payload !== undefined) {
          console.log("payload:", payload);
          try {
               // OWASP A02: Store auth payload in sessionStorage only (no JWT/token in localStorage - prevents XSS token theft)
               if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.setItem(AUTH_PAYLOAD_KEY, JSON.stringify(payload));
                    console.log("setAllValue: Stored auth payload in sessionStorage");
               }
               // Clear any legacy token from localStorage so we never persist auth there
               ls.remove('token');
               try { await SecureStorage.removeItem('token_secure'); } catch (_) {}
               resetSessionTimer();
          } catch (error) {
               console.error('Error storing auth payload:', error);
          }
     }
}

function processPlaceObject(geocoderResults) {
     let parsedAddress = {
          addressLineOne: "",
          locality: "",
          zipcode: "",
          city: "",
          state: "",
          country: ""
     };

     for (let i = 0; i < geocoderResults.length; i++) {
          const result = geocoderResults[i];
          const addressComponents = result.address_components;

          for (const component of addressComponents) {
               const types = component.types;
               if (i === 0) {
                    let addressLineTypes = ['street_number', 'route', 'sublocality_level_1', 'sublocality', 'locality'];
                    for (let alti in addressLineTypes) {
                         let addrType = addressLineTypes[alti];
                         if (types.includes(addrType)) {
                              parsedAddress.addressLineOne = parsedAddress.addressLineOne ? parsedAddress.addressLineOne + ", " + component.long_name : component.long_name;
                              break;
                         }
                    }
               }
               if (types.includes("sublocality") || types.includes("sublocality_level_1") && !parsedAddress.locality) {
                    parsedAddress.locality = component.long_name;
               }

               if (types.includes("locality") && !parsedAddress.city) {
                    parsedAddress.city = component.long_name;
               }

               if (types.includes("administrative_area_level_1") && !parsedAddress.state) {
                    parsedAddress.state = component.long_name;
               }

               if (types.includes("country") && !parsedAddress.country) {
                    parsedAddress.country = component.long_name;
               }

               if (types.includes("postal_code") && !parsedAddress.zipcode) {
                    parsedAddress.zipcode = component.long_name;
               }
          }
          if (parsedAddress.latitude === null || parsedAddress.latitude === undefined) {
               parsedAddress.latitude = result.geometry.location.lat();
               parsedAddress.longitude = result.geometry.location.lng();
               parsedAddress.placeId = result.id;
          }
          // Stop searching if we have both an address line and a postal code
          if (parsedAddress.addressLineOne &&
               parsedAddress.locality &&
               parsedAddress.city &&
               parsedAddress.state &&
               parsedAddress.country &&
               parsedAddress.zipcode) break;
     }
     // console.log("parsedAddress:",parsedAddress);

     return parsedAddress;
}

function isUserLoggedIn() {
     return new Promise((resolve) => {
          getValue().then(async (pLoadData) => {
               if (pLoadData && pLoadData['isloggedin']) {
                    resolve({ "flag": true });
               } else {
                    ls.clear();
                    document.location.href = '/home';
               }
          });
     })
}

function PrivateRoute({ component: Component, cprops, ...rest }) {
     console.log("PrivateRoute:")
     const [payloadData, setPayloadData] = useState(null);
     const [isValid, setIsValid] = useState(false);
     const [isAccessable, setIsAccessable] = useState(null);
     const location = useLocation();
     const history = useNavigate();

     const getMappedPriority = (pData, roleKey) => {
          if (!pData || !pData.roleMap || !roleKey) return null;
          const val = pData.roleMap[roleKey];
          if (val === null || val === undefined) return null;
          // Support both shapes:
          // - roleMap['hr'] = 5
          // - roleMap['hr'] = { id, name, code, priority }
          if (typeof val === 'number') return val;
          if (typeof val === 'string' && val !== '' && !Number.isNaN(Number(val))) return Number(val);
          if (typeof val === 'object' && val.priority != null) return val.priority;
          return null;
     };

     useEffect(() => {
          let valid = false;
          let accessable = false;
          getValue().then((pData) => {
               console.log('loggedvlue:', pData);
               pData = pData ? pData : {};
               valid = (pData['isloggedin'] !== undefined
                    && pData['isloggedin'] !== null
                    && pData['isloggedin'] === true) ? true : false;
               const path = rest.match;
               // 0: {id: 1, name: "Admin", code: "admin", priority: 1}
               // 6: {id: 7, name: "Operations Head", code: "operationshead", priority: 2}
               // 3: {id: 4, name: "Happiness Partner", code: "chp", priority: 3}
               // 1: {id: 2, name: "Client Admin", code: "ca", priority: 4}
               // 2: {id: 3, name: "HR", code: "hr", priority: 5}
               // 5: {id: 6, name: "Operations", code: "operations", priority: 6}
               // 7: {id: 8, name: "Data Entry", code: "de", priority: 7}
               // 4: {id: 5, name: "Accounts", code: "accounts", priority: 8}
               // 8: {id: 9, name: "Report Viewer", code: "reportviewer", priority: 9}
               // 9: {id: 9, name: "Document Viewer", code: "documentviewer", priority: 9}


               const role = pData['roleCode'];
               const roleNorm = (role || '').toLowerCase();

               // let accessableUrls = {
               //      admin: ['/chooseRole', '/onboarding', '/dashboard', '/adminDashboard', '/operations'],
               //      operationshead: ['/onboarding', '/dashboard', '/adminDashboard'],
               //      chp: ['/onboarding', '/dashboard', '/adminDashboard'],
               //      ca: ['/onboarding', '/dashboard'],
               //      hr: ['/onboarding', '/dashboard'],
               //      operations: ['/operations'],
               //      vendor: ['/vendorDashboard'],
               //      candidate: ['/candidate'],
               // }
               // if (role) {
               //      if( (role==='chp' || role==='operationshead' ) &&  getValue('additionalRole')){
               //           accessableUrls[role].push('/chooseRole')
               //           accessableUrls[role].push('/operations')
               //      }
               // }
               if (role) {
                    console.log('loggedRole---', role)
                    console.log('loggedpath---', path)
                    // Admin users should always have access to all modules
                    if (roleNorm === 'admin') {
                         accessable = true;
                    } else {
                    switch (path) {

                         case '/chooseRole':
                              // if (((getValue('rolePriority') === getValue('roleMap')['admin'] || (getValue('rolePriority') === getValue('roleMap')['de'])) ||
                              //      ((role === 'chp' || role === 'operationshead') && getValue('additionalRole') && getValue('additionalRole').length))) {
                              if ((pData['rolePriorityList'].length >= 2)) {
                                   accessable = true;
                              }
                              break
                         case '/operations':
                              // if ((role === 'operations') ||
                              // ((getValue('rolePriority') <= getValue('roleMap')['chp']) && getValue('additionalRole') && getValue('additionalRole').length)) {
                              accessable = true;
                              // }
                              break;
                         case '/adminDashboard':
                              // Admin users should always have access
                              {
                                   const chpPriority = getMappedPriority(pData, 'chp');
                                   if (roleNorm === 'admin' || (pData['rolePriority'] != null && chpPriority != null && (pData['rolePriority'] <= chpPriority))) {
                                   accessable = true;
                              }
                              }
                              break;
                         case '/dashboard':
                         case '/onboarding':
                         case '/socialIntelligence':
                              {
                                   const hrPriority = getMappedPriority(pData, 'hr');
                                   if (pData['rolePriority'] != null && hrPriority != null && (pData['rolePriority'] <= hrPriority)) {
                                   accessable = true;
                              }
                              }
                              break;
                         case '/vendorDashboard':
                              if (role === 'vendor') {
                                   accessable = true;
                              }
                              break;
                         case '/candidate':
                              if (role === 'candidate') {
                                   accessable = true;
                              }
                              break;
                         case '/reportViewerDashboard':
                              if (role === 'reportviewer') {
                                   accessable = true;
                              }
                              break;
                         case '/documentViewerDashboard':
                              if (role === 'documentviewer') {
                                   accessable = true;
                              }
                              break;
                         case '/dataEntry':
                              {
                                   const adminPriority = getMappedPriority(pData, 'admin');
                                   if (roleNorm === 'de' || (pData['rolePriority'] != null && adminPriority != null && (pData['rolePriority'] <= adminPriority))) {
                                   accessable = true;
                              }
                              }
                              break;
                         case '/qcDashboard':
                              {
                                   const adminPriority = getMappedPriority(pData, 'admin');
                                   if (roleNorm === 'qc' || (pData['rolePriority'] != null && adminPriority != null && (pData['rolePriority'] <= adminPriority))) {
                                   accessable = true;
                              }
                              }
                              break;
                         case '/caseCreation':
                         case '/bgvCaseCreation':
                              {
                                   const hrPriority = getMappedPriority(pData, 'hr');
                                   if (pData['rolePriority'] != null && hrPriority != null && (pData['rolePriority'] <= hrPriority)) {
                                   accessable = true;
                              }
                              }
                              break;
                         default:
                              document.location.href = '/';
                    }
                    }
               } else {
                    if ((pData['rolePriorityList'] && pData['rolePriorityList'].length >= 2)) {
                         accessable = true;
                    }
               }
               setIsValid(valid);
               setIsAccessable(accessable);
               setPayloadData(pData);
          })
     }, [rest.match, location.pathname])

     // waiting for payload data from localstore
     if (!payloadData) {
          return (<></>);
     }

     // console.log("valid && isAccessable:",isValid +"&&"+ isAccessable,payloadData)
     if (payloadData) {
          if (!isValid) {
               return <Navigate to="/" replace />;
          }
          if (!isAccessable) {
               return <ErrorPage type="403" />;
          }
     }

     return <Component {...cprops} location={location} history={history} {...rest} />

}


async function processLogout() {
     try {
          if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(AUTH_PAYLOAD_KEY);
          await SecureStorage.clear();
     } catch (error) {
          console.error('Error clearing secure storage:', error);
     }
     ls.clear();
}

let idleTimer = null;
let warningTimer = null;
const IDLE_TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutes
const IDLE_WARNING_DURATION = IDLE_TIMEOUT_DURATION - (15 * 1000); // Show warning 15 seconds before timeout

function resetSessionTimer() {
     // Clear existing timers
     if (idleTimer) {
          clearTimeout(idleTimer);
          idleTimer = null;
     }
     if (warningTimer) {
          clearTimeout(warningTimer);
          warningTimer = null;
     }

     const payload = getAuthPayloadSync();
     if (payload) {
          // Set warning timer (15 seconds before timeout)
          warningTimer = setTimeout(() => {
               console.log("Showing idle timeout warning");
               window.dispatchEvent(new CustomEvent('showSessionDialog', {
                    detail: { type: 'idle', countdown: 15 }
               }));
          }, IDLE_WARNING_DURATION);

          // Set actual timeout timer
          idleTimer = setTimeout(async () => {
               console.log("Session timed out due to inactivity");
               // Hide dialog if still showing
               window.dispatchEvent(new CustomEvent('hideSessionDialog'));
               try {
                    // Attempt to call logout API
                    const dataSource = new RestDataSource(`${restbaseurl}/login/logout`);
                    dataSource.GetData(async () => {
                         await processLogout();
                         window.location.replace('/');
                    }, {}, "POST");
               } catch (e) {
                    // Fallback direct logout
                    await processLogout();
                    window.location.replace('/');
               }
          }, IDLE_TIMEOUT_DURATION);
     }
}

// Listen for reset events (when user clicks "Stay Logged In")
if (typeof window !== 'undefined') {
     window.addEventListener('resetIdleTimer', resetSessionTimer);
}

function setupSessionTimeout() {
     console.log("Setting up session timeout...");

     // Track these events for user activity
     const activityEvents = ['mousemove', 'keypress', 'scroll', 'click', 'touchstart'];
     activityEvents.forEach(event => {
          window.addEventListener(event, resetSessionTimer, { passive: true });
     });

     // Initial start
     resetSessionTimer();
}

function importGoogleMapsJS() {
     // Check if Google Maps is already loaded
     if (window.google && window.google.maps) {
          console.log("Google Maps API already loaded");
          window.dispatchEvent(new CustomEvent('googleMapsLoaded'));
          return;
     }
     
     // Check if script is already being loaded
     const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
     if (existingScript) {
          console.log("Google Maps script already exists, waiting for load...");
          existingScript.addEventListener('load', () => {
               console.log("Existing Google Maps script loaded");
               window.dispatchEvent(new CustomEvent('googleMapsLoaded'));
          });
          return;
     }
     
     const payload = getAuthPayloadSync();
     const isLoggedIn = payload && payload.isloggedin;
     // VAPT: Only request Google Maps API key when user is logged in (do not expose key to unauthenticated clients)
     if (!isLoggedIn) {
          console.log("User not logged in, deferring Google Maps API load");
          const checkLoginInterval = setInterval(() => {
               const newPayload = getAuthPayloadSync();
               if (newPayload) {
                    clearInterval(checkLoginInterval);
                    console.log("User logged in, loading Google Maps API");
                    importGoogleMapsJS();
               }
          }, 1000);
          
          // Stop checking after 30 seconds
          setTimeout(() => {
               clearInterval(checkLoginInterval);
          }, 30000);
          return;
     }
     
     console.log("Google maps - requesting API key")
     let keyRequest = new RestDataSource(`${restbaseurl}/login/obtainGoogleMapsApiKey`)

     keyRequest.GetData(
          response => {
               console.log("Google Maps API key response:", response);
               
               // Check for error responses (401, etc.)
               if (response.error || (response.status === false)) {
                    const errorMsg = response.error || response.message || 'Failed to obtain Google Maps API key. Please ensure you are logged in.';
                    console.error("Error loading Google Maps API key:", response);
                    console.error("Error details:", errorMsg);
                    
                    // If it's an auth error, retry after a delay (user might be logging in)
                    if (response.error && (response.error.includes('Unauthorized') || response.error.includes('login'))) {
                         console.log("Authentication error, will retry after 2 seconds...");
                         setTimeout(() => {
                              const retryPayload = getAuthPayloadSync();
                              if (retryPayload || (retryPayload && retryPayload.isloggedin)) {
                                   console.log("Retrying Google Maps API key request...");
                                   importGoogleMapsJS();
                              } else {
                                   window.dispatchEvent(new CustomEvent('googleMapsLoadError', { 
                                        detail: { 
                                             error: errorMsg, 
                                             response: response,
                                             isAuthError: true
                                        } 
                                   }));
                              }
                         }, 2000);
                         return;
                    }
                    
                    window.dispatchEvent(new CustomEvent('googleMapsLoadError', { 
                         detail: { 
                              error: errorMsg, 
                              response: response,
                              isAuthError: response.error && (response.error.includes('Unauthorized') || response.error.includes('login'))
                         } 
                    }));
                    return;
               }
               
               if (response.status === true && response.key && response.key.length > 0) {
                    // Check if script already exists to avoid duplicate loading
                    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
                         console.log("Google Maps script already exists");
                         return;
                    }
                    
                    const script = document.createElement("script");
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${response.key}&libraries=places`;
                    script.async = true;
                    script.defer = true;

                    // Add load event listener
                    script.onload = () => {
                         console.log("Google Maps API script loaded successfully");
                         // Dispatch custom event to notify components
                         window.dispatchEvent(new CustomEvent('googleMapsLoaded'));
                    };

                    script.onerror = () => {
                         console.error("Failed to load Google Maps API script");
                         window.dispatchEvent(new CustomEvent('googleMapsLoadError', { 
                              detail: { error: 'Failed to load Google Maps script from Google servers' } 
                         }));
                    };

                    document.body.appendChild(script);
                    console.log("Google Maps script added to DOM");
               }
               else {
                    const errorMsg = response.error || response.message || 'Invalid API key response';
                    console.error("Error loading Google Maps JS - invalid response", response);
                    window.dispatchEvent(new CustomEvent('googleMapsLoadError', { 
                         detail: { error: errorMsg, response: response } 
                    }));
               }
          },
          {},
          "POST"
     );

}

export {
     parseJwt, updateC1, updateUserInfo, processLogout, getValue, setValue, setAllValue, getAuthPayloadSync, processPlaceObject, isUserLoggedIn, PrivateRoute, importGoogleMapsJS, setupSessionTimeout
};
